import jsPDF from "jspdf";
import autoTable from "jspdf-autotable";

const MutasiRealisasi = (periode, data, namaBulan, tahun, jenisPin) => {
  const doc = new jsPDF("landscape");
  const pageWidth = doc.internal.pageSize.getWidth();
  const pageHeight = doc.internal.pageSize.getHeight();

  const namaPiutang = jenisPin === "A" ? "Piutang A" : "Piutang D";
  const judul = `Mutasi Realisasi ${namaPiutang}`;
  const subJudul = `${namaBulan} ${tahun}`;

  const formatNumber = (num) => Number(num || 0).toLocaleString("id-ID");

  const loadImageAsDataURL = (url) =>
    fetch(url)
      .then((res) => res.blob())
      .then(
        (blob) =>
          new Promise((resolve, reject) => {
            const reader = new FileReader();
            reader.onloadend = () => resolve(reader.result);
            reader.onerror = reject;
            reader.readAsDataURL(blob);
          })
      );

  const drawHeader = (logoDataUrl) => {
    const logoX = 14;
    const logoY = 8;
    const logoSize = 18;
    const textX = logoX + logoSize + 3;

    if (logoDataUrl) {
      doc.addImage(logoDataUrl, "PNG", logoX, logoY, logoSize, logoSize);
    }

    doc.setFont("helvetica", "bold");
    doc.setFontSize(12);
    doc.text("KPRI SRI REJEKI", textX, 15);
    doc.setFont("helvetica", "normal");
    doc.setFontSize(10);
    doc.text("Jl. Donomulyo No.164 Kab. Malang", textX, 21);

    const lineY = logoY + logoSize + 4;
    doc.setLineWidth(0.5);
    doc.line(14, lineY, pageWidth - 14, lineY);

    const reportY = lineY + 8;
    doc.setFont("helvetica", "bold");
    doc.setFontSize(14);
    doc.text(judul, pageWidth / 2, reportY, { align: "center" });
    doc.setFont("helvetica", "normal");
    doc.setFontSize(11);
    doc.text(subJudul, pageWidth / 2, reportY + 7, { align: "center" });

    return reportY + 13;
  };

  const headers = [
    [
      "No",
      "Tanggal",
      "No Realisasi",
      "No Anggota",
      "Nama",
      "Pinjaman",
      "Angsuran Ke",
      "Angsuran",
      "Administrasi",
      "DPHA",
    ],
  ];

  let totalPinjaman = 0;
  let totalAngsuran = 0;
  let totalAdministrasi = 0;
  let totalDpha = 0;

  const tableData = data.map((item, index) => {
    const pinjaman = Number(item.pinjaman || 0);
    const angsuran = Number(item.angsuran || 0);
    const administrasi = Number(item.administrasi || 0);
    const dpha = Number(item.dpha || 0);

    totalPinjaman += pinjaman;
    totalAngsuran += angsuran;
    totalAdministrasi += administrasi;
    totalDpha += dpha;

    const tanggalFormatted = item.tanggal
      ? new Date(item.tanggal).toLocaleDateString("id-ID", {
          day: "2-digit",
          month: "2-digit",
          year: "numeric",
        })
      : "-";

    return [
      { content: index + 1, styles: { halign: "center" } },
      { content: tanggalFormatted, styles: { halign: "center" } },
      { content: item.norealisasi || "-", styles: { halign: "center" } },
      { content: item.noanggota || "-", styles: { halign: "center" } },
      { content: item.nama || "-" },
      { content: formatNumber(pinjaman), styles: { halign: "right" } },
      { content: item.xangsur || "-", styles: { halign: "center" } },
      { content: formatNumber(angsuran), styles: { halign: "right" } },
      { content: formatNumber(administrasi), styles: { halign: "right" } },
      { content: formatNumber(dpha), styles: { halign: "right" } },
    ];
  });

  tableData.push([
    { content: "", styles: { halign: "center" } },
    { content: "TOTAL", colSpan: 4, styles: { fontSize: 8, halign: "center", fontStyle: "bold" } },
    { content: formatNumber(totalPinjaman), styles: { fontSize: 8, halign: "right", fontStyle: "bold" } },
    { content: "", styles: { fontSize: 8, halign: "center" } },
    { content: formatNumber(totalAngsuran), styles: { fontSize: 8, halign: "right", fontStyle: "bold" } },
    { content: formatNumber(totalAdministrasi), styles: { fontSize: 8, halign: "right", fontStyle: "bold" } },
    { content: formatNumber(totalDpha), styles: { fontSize: 8, halign: "right", fontStyle: "bold" } },
  ]);

  const renderTable = (startY) => {
    autoTable(doc, {
      head: headers,
      body: tableData,
      startY,
      theme: "grid",
      margin: { left: 14, right: 14, top: 20, bottom: 10 },
      tableWidth: "page",
      headStyles: {
        halign: "center",
        valign: "middle",
        fontSize: 7,
        cellPadding: 2,
        fillColor: [32, 178, 170],
        textColor: 255,
        fontStyle: "bold",
      },
      styles: {
        fontSize: 7,
        cellPadding: 1.5,
        overflow: "linebreak",
        valign: "middle",
      },
      showHead: "everyPage",
      columnStyles: {
        0: { cellWidth: "auto", halign: "center" },
        1: { cellWidth: "auto", halign: "center" },
        2: { cellWidth: "auto", halign: "center" },
        3: { cellWidth: "auto", halign: "center" },
        4: { cellWidth: "auto", halign: "left" },
        5: { cellWidth: "auto", halign: "right" },
        6: { cellWidth: "auto", halign: "center" },
        7: { cellWidth: "auto", halign: "right" },
        8: { cellWidth: "auto", halign: "right" },
        9: { cellWidth: "auto", halign: "right" },
      },
      didParseCell: (tableCell) => {
        if (
          tableCell.row.raw &&
          tableCell.row.raw[1]?.content === "TOTAL"
        ) {
          tableCell.cell.styles.fontStyle = "bold";
          tableCell.cell.styles.fillColor = [230, 230, 230];
          if (tableCell.column.index >= 5)
            tableCell.cell.styles.halign = "right";
        }
      },
      didDrawPage: (pageData) => {
        doc.setFontSize(8);
        doc.setFont("helvetica", "normal");
        doc.text(
          `Page ${doc.internal.getNumberOfPages()}`,
          pageData.settings.margin.left,
          pageHeight - 8
        );
      },
    });

    const pdfBlob = doc.output("blob");
    window.open(URL.createObjectURL(pdfBlob), "_blank");
  };

  const customLogoUrl = "/koperasihitamputih.png";
  loadImageAsDataURL(customLogoUrl)
    .then((logoDataUrl) => renderTable(drawHeader(logoDataUrl)))
    .catch(() => renderTable(drawHeader()));
};

export default MutasiRealisasi;
